module.exports = __webpack_public_path__ + "img/adulto37.261c38a2.jpg";